module.exports = __webpack_public_path__ + "static/img/AITutorialRight.b3b5ff93.png";